import * as React from 'react';
export const IcSim2 = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.12 2.88A3 3 0 0016 2h-5a3 3 0 00-2.38 1.13l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-.88-2.12zM14.5 17H10a1 1 0 01-.77-1.63l3.26-4a.82.82 0 00.07-1.19.79.79 0 00-1.12 0 .61.61 0 00-.12.16.769.769 0 00-.1.25.71.71 0 000 .15 1 1 0 01-2 0 2.76 2.76 0 010-.51 2.5 2.5 0 01.32-.89 2.71 2.71 0 01.46-.56 2.807 2.807 0 113.94 4L12.11 15h2.39a1 1 0 110 2z'
      fill='currentColor'
    />
  </svg>
);
